

const BrandStoryHero = () => {
    return (
        <section className="py-24 sm:py-10 px-10 sm:p-20 flex flex-col gap-8 sm:gap-4 items-center">
            <img 
            className="w-[230px] sm:w-[300px]"
            src="https://pillup.com/assets/logo.svg" alt="Company logo" />
            <h3 className="text-center sm:w-[70%] text-xl sm:text-2xl font-serif leading-[37px] sm:leading-10">From chronic medication to vitamins and health supplements, we pack, organize and deliver your medicines to your doorstep at no extra cost.</h3>             
        </section>
    )
}

export default BrandStoryHero